import { useState } from 'react'
import { Box, Popover, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import i18next from 'i18next'

import { useUser } from 'store'
import CardActionButton from 'components/global/CardActions/CardActionButton'

import { TagAdvertisements } from '../TagAdvertisements'

const Creator = ({ advertisement }) => {
  return (
    <Box display={'flex'} gap={0.5}>
      <Typography variant="caption">{advertisement.creator.first_name}</Typography>
      <Typography variant="caption">{advertisement.creator.last_name}</Typography>
    </Box>
  )
}

const BroadcastPeriod = ({ advertisement }) => {
  return (
    <Box display={'flex'} alignItems={'center'} gap={1}>
      <Typography variant="caption">
        {new Date(advertisement.starts_at).toLocaleDateString(i18next.language)}
      </Typography>
      <i className="fa-regular fa-arrow-right" />
      <Typography variant="caption">{new Date(advertisement.ends_at).toLocaleDateString(i18next.language)}</Typography>
    </Box>
  )
}

const Account = ({ advertisement }) => {
  const { t } = useTranslation()
  const [anchorEl, setAnchorEl] = useState(null)

  const handlePopoverOpen = event => {
    if (advertisement.count_accounts < 2) {
      return
    }
    setAnchorEl(event.target)
  }
  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  return (
    <Box>
      <Box onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose}>
        <Typography variant="caption">{advertisement.count_accounts}</Typography>
      </Box>
      <Popover
        sx={{
          pointerEvents: 'none'
        }}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}>
        <Stack color={'white'} bgcolor={'grey.700'} p={'4px 6px'}>
          <Typography fontSize={11} fontWeight={500}>
            {t('advertisements.table.tooltip_click_for_details')}
          </Typography>
        </Stack>
      </Popover>
    </Box>
  )
}

const Sites = ({ advertisement }) => {
  const { t } = useTranslation()

  const [anchorEl, setAnchorEl] = useState(null)

  const handlePopoverOpen = async event => {
    if (advertisement.count_sites < 2) {
      return
    }
    setAnchorEl(event.target)
  }
  const handlePopoverClose = () => {
    setAnchorEl(null)
  }
  return (
    <Box>
      <Box onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose}>
        <Typography variant="caption">{advertisement.count_sites}</Typography>
      </Box>
      <Popover
        sx={{
          pointerEvents: 'none'
        }}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}>
        <Stack color={'white'} bgcolor={'grey.700'} p={'4px 6px'}>
          <Typography fontSize={11} fontWeight={500}>
            {t('advertisements.table.tooltip_click_for_details')}
          </Typography>
        </Stack>
      </Popover>
    </Box>
  )
}

const Actions = ({ id }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [user] = useUser()
  return (
    <Box display={'flex'} gap={2}>
      <CardActionButton
        iconlabel={'pen'}
        tooltiptitle={t('advertisements.table.tooltip_edit_button')}
        disabled={Boolean(user.demo_mode)}
        onClick={e => {
          e.stopPropagation()
          navigate(`/advertisements/${id}/edit`)
        }}
      />
      <CardActionButton
        iconlabel={'trash'}
        tooltiptitle={t('advertisements.table.tooltip_delete_button')}
        disabled={Boolean(user.demo_mode)}
        onClick={e => {
          e.stopPropagation()
          navigate(`/advertisements/${id}/delete`)
        }}
      />
    </Box>
  )
}

const COLUMNS_CONFIG = [
  {
    name: 'availability',
    header: {
      label: ctx => ctx.t('advertisements.table.status')
    },
    value: advertisement => <TagAdvertisements status={advertisement.status} />
  },
  {
    name: 'titles',
    header: {
      label: ctx => ctx.t('advertisements.table.title')
    },
    value: advertisement => advertisement.name,
    sortBy: 'name',
    sortable: true
  },
  {
    name: 'created_by',
    header: {
      label: ctx => ctx.t('advertisements.table.created_by')
    },
    value: advertisement => <Creator advertisement={advertisement} />
  },
  {
    name: 'period',
    header: {
      label: ctx => ctx.t('advertisements.table.broadcast_period')
    },
    value: advertisement => <BroadcastPeriod advertisement={advertisement} />,
    sortBy: 'starts_at',
    sortable: true
  },
  {
    name: 'account',
    header: {
      label: ctx => ctx.t('advertisements.table.account')
    },
    value: advertisement => <Account advertisement={advertisement} />
  },
  {
    name: 'site',
    header: {
      label: ctx => ctx.t('advertisements.table.site')
    },
    value: advertisement => <Sites advertisement={advertisement} />
  },
  {
    name: 'actions',
    header: {
      label: ctx => ctx.t('advertisements.table.actions'),
      className: 'actions'
    },
    value: advertisement => advertisement.can_be_edit && <Actions id={advertisement.id} />
  }
]

export default COLUMNS_CONFIG
